import classNames from 'classnames'
import React from 'react'

import {StandaloneMenuHeader} from './types'
import styles from './styles.module.css'

type Props = {
  header: StandaloneMenuHeader
  current: boolean
}

const MenuHeader: React.FC<Props> = ({header, current}) => {
  return (
    <li className={styles.navigationItem}>
      <a
        className={classNames(styles.link, {[`${styles.current}`]: current})}
        href={header.url}
      >
        {header.label}
      </a>
    </li>
  )
}

export default MenuHeader
